__turbopack_context__.v({
  "product-suite-image-enter": "product-suite-module__5KLIpq__product-suite-image-enter",
  "productImage": "product-suite-module__5KLIpq__productImage",
});
